import { Tooltip } from "react-tooltip";
import { colors, typography } from "../../../design/tokens";
import { ProjectModalProvider } from "../../../providers/ProjectModalProvider";
import {
  DashboardMode,
  useDashboardMode,
  useWorkspaceSection,
  WorkspaceSection,
} from "../../../view_stores/useDashboardControlsStore";
import { useProjectName } from "../../../view_stores/useProjectConfigStore";
import {
  PreviewUrlStatus,
  useProjectPreviewStatus,
} from "../../../view_stores/useProjectPreviewStore";
import {
  ProjectStatus,
  useIsProjectProcessing,
  useProjectStatus,
} from "../../../view_stores/useProjectStatusStore";
import { SplitPanel } from "../../common_components/SplitPanel";
import { ProjectFilesLazy } from "../../projectFiles/ProjectFilesLazy";
import { ProjectPreview } from "../../projectPreview/ProjectPreview";
import { ProjectWorkspaceContent } from "./ProjectWorkspaceContent";
import { ProjectWorkspaceMenu } from "./ProjectWorkspaceMenu";

export function ProjectDashboard() {
  const isProjectProcessing = useIsProjectProcessing();
  const projectName = useProjectName();
  const previewStatus = useProjectPreviewStatus();
  const hasNeededData = projectName;

  return (
    <div
      className="h-full w-full flex flex-col relative
      bg-dark-surface-primary"
    >
      <ProjectModalProvider>
        {hasNeededData && previewStatus !== PreviewUrlStatus.NotAvailable && (
          <div className="flex-1 overflow-hidden w-full">
            <Content />
          </div>
        )}
        {isProjectProcessing &&
          previewStatus === PreviewUrlStatus.NotAvailable && <ProcessingInfo />}
        <Tooltip
          id="dashboard-tooltip"
          className="max-w-[500px]"
          place="top"
          opacity={1.0}
          clickable={true}
        />
      </ProjectModalProvider>
    </div>
  );
}

function Content() {
  const dashboardMode = useDashboardMode();
  const workspaceSection = useWorkspaceSection();

  return (
    <>
      {/* Preview - always mounted, visibility controlled by CSS to prevent iframe reload on mode switch */}
      <div
        className={
          dashboardMode === DashboardMode.PREVIEW
            ? "block w-full h-full"
            : "hidden"
        }
      >
        <ProjectPreview />
      </div>

      {/* Workspace content - conditionally rendered */}
      {dashboardMode === DashboardMode.WORKSPACE &&
        (workspaceSection === WorkspaceSection.CODE ? (
          <ProjectFilesLazy />
        ) : (
          <SplitPanel
            leftChild={<ProjectWorkspaceMenu />}
            rightChild={<ProjectWorkspaceContent />}
            initialLeftChildWidth={25}
            minRightChildWidth={300}
          />
        ))}
    </>
  );
}

function ProcessingInfo() {
  const projectName = useProjectName();
  const projectStatus = useProjectStatus();

  if (!projectName || projectStatus === ProjectStatus.JOB_DONE) {
    return null;
  }

  return (
    <div
      className="flex flex-col items-center justify-center
    absolute top-0 left-0
    w-full h-full
    bg-black/10 dark:bg-black/25"
    >
      <p
        className={`${typography.size.base} ${typography.weight.semibold} ${colors.text.primary}`}
      >
        Building your app...
      </p>
    </div>
  );
}
